import { useState, useEffect } from "react";
import { Switch, Button, FormControlLabel } from "@mui/material";
import { fetchUserInfo, updateTwoFactorAuth } from "../services/twoFactorAuthService";
import LoadingSpinner from "../components/LoadingSpinner";
import SnackbarMessage from "../components/SnackBAr/SnackbarNotification";

const TwoFactorAuth = () => {
    const [is2FAEnabled, setIs2FAEnabled] = useState(false);
    const [loading, setLoading] = useState(true);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState<'success' | 'info' | 'warning' | 'error'>('info');

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const isEnabled = await fetchUserInfo();
                setIs2FAEnabled(isEnabled);
                setSnackbarMessage("Fetched user info successfully");
                setSnackbarSeverity('success');
            } catch (error) {
                console.error("Error fetching user info:", error);
                setSnackbarMessage("Error fetching user info");
                setSnackbarSeverity('error');
            } finally {
                setLoading(false);
                setSnackbarOpen(true);
            }
        };

        fetchData();
    }, []);

    const handle2FAToggle = (event: { target: { checked: boolean | ((prevState: boolean) => boolean); }; }) => {
        setIs2FAEnabled(event.target.checked);
    };

    const handleSave = async () => {
        setLoading(true);
        try {
            await updateTwoFactorAuth( is2FAEnabled);
            setSnackbarMessage("2FA status updated successfully");
            setSnackbarSeverity('success');
        } catch (error) {
            setSnackbarMessage("Error updating 2FA status");
            setSnackbarSeverity('error');
            console.error("Error updating 2FA:", error);
        } finally {
            setLoading(false);
            setSnackbarOpen(true);
        }
    };

    const handleCancel = () => {
        setIs2FAEnabled(false);
        setSnackbarMessage("Cancelled Successfully");
        setSnackbarSeverity('info');
        setSnackbarOpen(true);
    };

    return (
        <div>
            {loading && <LoadingSpinner show={false} onComplete={function (): void {
                throw new Error("Function not implemented.");
            } } />}

            {!loading && (
                <>
                    <FormControlLabel
                        label="Enable 2FA"
                        control={<Switch checked={is2FAEnabled} onChange={handle2FAToggle} />}
                        labelPlacement="start"
                    />

                    <div className="flex justify-center space-x-4 mt-6">
                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: 'white',
                                border: '2px solid #0870b4',
                                color: '#000000',
                                transition: 'background-color 0.3s ease, border-color 0.3s ease, transform 0.3s ease',
                                transform: 'scale(1)',
                                '&:hover': {
                                    color: '#0870b4',

                                    borderColor: '#0870b4',

                                },
                            }}
                            onClick={handleCancel}
                        >
                            Cancel
                        </Button>

                        <Button
                            variant="contained"
                            color="primary"
                            className="bg-gradient-to-r from-primary to-primary text-white hover:from-primary hover:to-primary"
                            onClick={handleSave}
                        >
                            Save
                        </Button>
                    </div>
                </>
            )}

            <SnackbarMessage
                open={snackbarOpen}
                message={snackbarMessage}
                severity={snackbarSeverity}
                onClose={handleSnackbarClose}
            />
        </div>
    );
};

export default TwoFactorAuth;
